import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../../lib/bem/index';

import './headerTitleMobil_Component.scss';

const HeaderTitleMobilComponent = ({title, desc, infoNro, indice}) => {

    const classes = cn("headerTitleMobilComponent");

    const setStyle = (indice, section) => {
        if( indice === section){
            return '#0080AA';
        } else if ( indice < section){
            return '#E7EBED';
        } else {
            return '#55BBDD';
        }
    }

    return (
        <div className={classes()}>
            <div className={classes("headerTitleMobilComponentDiv")}>
                <p className={classes("headerTitleMobilComponentDivTit")}><b>{title}</b></p>
                <p className={classes("headerTitleMobilComponentDivDes")}>{desc}</p>
            </div>
            <div>
                {/* <ul className='pie'>
                    <li className='slice'>
                        <div id="top" className='slice-contents' style={{background: setStyle(indice, 1)}}></div>
                    </li>
                    <li className='slice'>
                        <div id="right" className='slice-contents' style={{background: setStyle(indice, 2)}}></div>
                    </li>
                    <li className='slice'>
                        <div id="left" className='slice-contents' style={{background: setStyle(indice, 3)}}></div>
                    </li>
                    <li className='slice'>
                        <div id="bottom" className='slice-contents' style={{background: setStyle(indice, 4)}}></div>
                    </li>
                    <li id="center" className='inner-pie'>
                        <p>{infoNro}</p>
                    </li>
                </ul> */}
                
                <div className="donut-chart">
                    <div id="part1" className="portion-block"><div className="circle" style={{background: setStyle(indice, 1)}}></div></div>
                    <div id="part2" className="portion-block"><div className="circle" style={{background: setStyle(indice, 2)}}></div></div>
                    {/* <div id="part3" className="portion-block"><div className="circle" style={{background: setStyle(indice, 3)}}></div></div> */}
                    <p className="center">{infoNro}</p>        
                </div>
            </div>
        </div>
    );
};

HeaderTitleMobilComponent.propTypes = {
    title   : PropTypes.string.isRequired,
    desc    : PropTypes.string.isRequired,
    infoNro : PropTypes.string.isRequired,
    indice  : PropTypes.number.isRequired
};

export default HeaderTitleMobilComponent;